import { render } from "preact";
import { Chatbot } from "./components/Chatbot";
import "./styles/chatbot.css";
import { getMonitoringService } from "./lib/monitoring";
import { KismetProvider } from "./contexts/KismetContext";

// Define the global configuration type for hot module replacement
declare global {
  interface ImportMeta {
    hot?: {
      accept: () => void;
    };
  }
}

function mountChatbot() {
  // Remove any existing chatbot container
  const existingContainer = document.getElementById("kismet-root");
  if (existingContainer) {
    existingContainer.remove();
  }

  // No need to reset monitoring service here - handled by subscription system

  // Create a container for our chatbot
  const chatbotContainer = document.createElement("div");
  chatbotContainer.id = "kismet-root";
  document.body.appendChild(chatbotContainer);

  // Render the chatbot with the provider
  render(
    <KismetProvider>
      <Chatbot />
    </KismetProvider>,
    chatbotContainer
  );
}

// Initial mount
mountChatbot();

// Handle page navigation
const handleUrlChange = () => {
  // console.debug("URL changed, remounting chatbot");

  // Call monitoring service's URL change handler
  const monitoring = getMonitoringService();
  monitoring.onUrlChange(window.location.href);

  // Remount chatbot
  mountChatbot();
};

// Monitor URL changes via History API
window.addEventListener("popstate", handleUrlChange);

// Override History API methods
const originalPushState = history.pushState;
history.pushState = function (...args) {
  originalPushState.apply(this, args);
  handleUrlChange();
};

const originalReplaceState = history.replaceState;
history.replaceState = function (...args) {
  originalReplaceState.apply(this, args);
  handleUrlChange();
};

// Enable hot module replacement
if (import.meta.hot) {
  import.meta.hot.accept();
}
